<template>
  <div>
    <Sidebar />
    <div class="content">
      <NavBar />
      <main>
        <div class="header">
          <div class="left">
            <h1>Orçamentos</h1>
          </div>
        </div>
        <div class="bottom-data">
          <div class="orders">
            <div class="header">
              <i class="bx bx-receipt"></i>
              <h3>Lista</h3>
              <router-link to="/orcamentos/adicionar" data-bs-placement="right" tooltip-bs-title="Adicionar Orçamento">
                <i class="bx bx-plus-circle icon-success"></i>
              </router-link>
            </div>
            <div class="row">
              <div class="col-md-4 col-12">
                <div class="form-input mb-3 ">
                  <input v-model="params.search" type="text" class="form-control" name="full_name"
                    placeholder="Pesquisar..." />
                </div>
              </div>

            </div>
            <vue3-datatable :rows="list" :columns="cols" @rowClick="handleRowClick" row-class="clickable-row"
              :sortable="true" :pagination="true" :pageSize="params.pagesize" :search="params.search"
              :paginationInfo="paginationInfo"></vue3-datatable>
          </div>
        </div>
      </main>
      <b-modal id="modal-view" ref="modal-view" title="Informações" class="box modal-lg" hide-footer>
        <div v-if="is_refresh_lead" class="d-flex gap-2 text-center mt-4 mb-4 justify-content-center">
          <i class='bx bx-refresh icon-primary'></i> Carregando ...
        </div>
        <div v-if="!is_refresh_lead">
          <div class="row">
            <div class="col-md-4 col-12" v-if="role != 3">
              <div class="form-input mb-3">
                <label for="" class="form-label">Valor do Kit</label>
                <money3 v-model="budgetItemAll[0].p_kit" v-bind="configMask" disabled></money3>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="form-input mb-3">
                <label for="" class="form-label">Instalação</label>
                <money3 v-model="budgetItemAll[0].p_install" v-bind="configMask" disabled></money3>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="form-input mb-3">
                <label for="" class="form-label">Insumo</label>
                <money3 v-model="budgetItemAll[0].p_supplie" v-bind="configMask" disabled></money3>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="form-input mb-3">
                <label for="" class="form-label">Deslocamento</label>
                <money3 v-model="budgetItemAll[0].p_distance" v-bind="configMask" disabled></money3>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="form-input mb-3">
                <label for="" class="form-label">Valor de Comissão (R$)</label>
                <money3 v-model="budgetItemAll[0].v_commission" v-bind="configMask" disabled></money3>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="form-input mb-3">
                <label for="" class="form-label">Valor de Desconto (R$)</label>
                <money3 v-model="budgetItemAll[0].v_discount" v-bind="configMask" disabled></money3>
              </div>
            </div>
            <div class="col-md-4 col-12" v-if="role != 3">
              <div class="form-input mb-3">
                <label for="" class="form-label">Lucro</label>
                <money3 v-model="budgetItemAll[0].p_amount" v-bind="configMask" disabled></money3>
              </div>
            </div>
            <div class="col-md-4 col-12" v-if="role != 3">
              <div class="form-input mb-3">
                <label for="" class="form-label">Imposto</label>
                <money3 v-model="budgetItemAll[0].p_taxes" v-bind="configMask" disabled></money3>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="form-input mb-3">
                <label for="" class="form-label">
                  <strong>Total</strong>
                </label>
                <money3 v-model="budgetItemAll[0].p_all_amout" v-bind="configMask" disabled></money3>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4 mt-3">
              <button class="btn btn-primary btn-all" @click="view(budgetItemAll[1].id)">Ver Orçamento</button>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import NavBar from "@/components/NavBar.vue";
import Sidebar from "@/components/SideBar.vue";
import { generateAndDownloadBudgetDocx } from "@/utils/budgetDocx";

import Vue3Datatable from "@bhplugin/vue3-datatable";
import "@bhplugin/vue3-datatable/dist/style.css";

export default {
  components: {
    NavBar,
    Sidebar,
    Vue3Datatable,
  },
  data() {
    return {
      budgetItemAll: [],
      is_refresh_lead: true,
      uuid: Cookie.get("link"),
      list: [],
      params: {
        current_page: 1,
        pagesize: 10,
        search: '',
        column_filters: [],
      },
      paginationInfo: 'Mostrando {0} a {1} de {2}',
      loading: true,
      token: "",
      cols: [
        { label: "ID", field: "id", sortable: true, title: "ID", type: "number" },
        { label: "Nome", field: "name", sortable: true, title: "Nome do cliente" },
        { label: "Telefone", field: "phone", sortable: true, title: "Telefone" },
        { label: "Valor Total", field: "amount", sortable: true, title: "Valor total" },
        { label: "Criação", field: "created_at", sortable: true, title: "Data de criação" }
      ],
    };
  },
  methods: {
    showAlert(type, msg) {
      let textMsg = msg?.message || msg;
      if (msg.errors) {
        textMsg = Object.values(msg.errors).map(err => err.join(", ")).join("<br>");
      }
      this.$swal({
        icon: type,
        confirmButtonText: "Confirmar",
        html: textMsg,
      });
    },
    handleRowClick(row) {

      this.is_refresh_lead = true;
      this.$refs['modal-view'].show()

      this.$http.get("user/budgets/" + row.id, {
        headers: {
          "Authorization": "Bearer " + this.token
        },
      })
        .then((response) => {
          this.budgetItemAll = JSON.parse(response.data.item.budget);

          if (Array.isArray(this.budgetItemAll)) {
            this.budgetItemAll.push({ id: response.data.item.id });
          } else {
            this.budgetItemAll = [this.budgetItemAll, { id: response.data.item.id }];
          }

          this.is_refresh_lead = false;
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            this.showAlert('error', error.response.data);
          } else {
            this.showAlert('error', 'Ocorreu um erro desconhecido. Entre em contato com a equipe de desenvolvimento.');
          }
        });
    },
    load() {
      if (!this.token) {
        console.error("Token não encontrado, abortando requisição.");
        this.loading = false;
        return;
      }

      this.$http
        .get("user/budgets", {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.list = response.data.items.map((item) => ({
            id: item.id,
            name: item.name || "Sem nome",
            phone: item.phone ? String(item.phone) : "Não informado",
            amount: this.convertAmount(item.amount),
            created_at: this.formatDate(1, item.created_at),
          }));

          this.$nextTick(() => {
            this.loading = false;
          });
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
          this.showAlert("error", error.response?.data || "Erro ao carregar orçamentos.");
        });
    },
    convertAmount(value) {
      return parseFloat(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    formatDate(type, date) {
      if (!date) return "";
      const dateFormat = new Date(date);
      return type == 0
        ? `${dateFormat.getDate().toString().padStart(2, "0")}/${(dateFormat.getMonth() + 1).toString().padStart(2, "0")}/${dateFormat.getFullYear()}`
        : `${dateFormat.getDate().toString().padStart(2, "0")}/${(dateFormat.getMonth() + 1).toString().padStart(2, "0")}/${dateFormat.getFullYear()} às ${dateFormat.getHours().toString().padStart(2, "0")}:${dateFormat.getMinutes().toString().padStart(2, "0")}`;
    },
    view(id) {
      const loader = this.$loading.show({
        canCancel: false,
      });
      generateAndDownloadBudgetDocx({
        baseUrl: this.$http.defaults.baseURL,
        budgetId: id,
        token: this.token,
      })
        .catch((e) => {
          this.showAlert(
            "error",
            (e && e.message) || "Não foi possível gerar o orçamento em Word."
          );
        })
        .finally(() => loader.hide());
    },
  },
  created() {
    this.token = Cookie.get("_token") || "";

    this.load();
  },
};
</script>
